import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const searchCodesResponseSchema = z.object({
  id: z.string(),
  codeType: z.string(),
  code: z.string(),
  price: z.number().nullish(),
  modifiers: z.any().nullish(),
  description: z.string().nullable(),
  userGroupCodeConfigId: z.string().nullable(),
});

export type SearchMedicalCodesResponse = z.infer<
  typeof searchCodesResponseSchema
>;

export const medicalCodesContract = c.router(
  {
    search: {
      method: 'GET',
      path: '/search',
      query: z.object({
        searchTerm: z.string(),
        locationId: z.string().optional(),
      }),
      responses: {
        200: z.array(searchCodesResponseSchema),
      },
    },

    generateDownloadUrlForAllCodes: {
      method: 'POST',
      path: '/generate-download-url-for-all-codes',
      body: z.object({}),
      responses: {
        200: z.object({
          downloadUrl: z.string(),
        }),
      },
    },

    generateDownloadUrlForGroupEnabledCodes: {
      method: 'POST',
      path: '/user-groups/:userGroupId/generate-download-url-for-enabled-codes',
      body: z.object({}),
      responses: {
        200: z.object({
          downloadUrl: z.string(),
        }),
      },
    },

    processMedicalCodesFile: {
      method: 'POST',
      path: '/user-groups/:userGroupId/upload-codes',
      body: z.object({
        userUploadId: z.string(),
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
          processed: z.number(),
          skipped: z.number(),
          errors: z.array(z.string()),
        }),
      },
    },
  },
  { pathPrefix: '/:tenantId/medical-codes' },
);
